var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.annuaire_file") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c("div", { staticClass: "requestsList" }, [
              _c("div", { staticClass: "mt-0" }, [
                _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      { staticClass: "text-xl-start justify-content-start" },
                      [
                        _c(
                          "b-col",
                          { attrs: { xl: "4", lg: "6", md: "6", cols: "12" } },
                          [
                            _c(
                              "b-button-group",
                              { staticClass: "my-3 mt-sm-0" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "px-4",
                                    attrs: {
                                      variant:
                                        _vm.tabName === 1
                                          ? "primary btn-selected"
                                          : "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeTabName(1)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Webheader.annuaire_client")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "px-4",
                                    attrs: {
                                      variant:
                                        _vm.tabName === 2
                                          ? "primary btn-selected"
                                          : "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeTabName(2)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Webheader.annuaire_file"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "p-0",
                            attrs: { cols: "6", lg: "4", xl: "2" },
                          },
                          [
                            _vm.canAddAnnuaireFile && !_vm.activateSpinner
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "mb-3 justify-item-end",
                                    attrs: { variant: "primary" },
                                    on: { click: _vm.addAnnuaireFile },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-light fa-plus",
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("annuaire.add_annuaire_file")
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.tabName === 1
                      ? _c("AnnuaireLineList", {
                          attrs: { type: _vm.TrackType, id: _vm.id },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tabName === 2 ? _c("AnnuaireFilePage") : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }